// Paleta categórica por defecto de las gráficas. El orden está validado para que los colores vecinos
// se distingan con daltonismo: no reordenar ni repetir colores cuando haya más categorías que colores.
export const ChartColorsConstants = {
  defaultColors: ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948']
}
